function getRegulator(SHA256) {
  if (SHA256 == '2214f7249d9af20b121d1b04fbf9ec1ff342e6b0d946f9c63a72741000638c1e') return 'fsa'
  else if (SHA256 == '3edb66ea075e148507b4547497333f55f63218596ac3acdad9eb49f8ce686f4c') return 'svg'
  else return 'fsa'
}

export { getRegulator }
